import { render } from "./bind-status.vue?vue&type=template&id=d08fcca6"
import script from "./bind-status.vue?vue&type=script&lang=js"
export * from "./bind-status.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__